
const validate = (props) => {
    const errors = {}
    if (!props.code) {
        errors.code = {
            ar: ' يرجى ادخال الكود ',
            en: 'Enter the code'
        }
    } 

    return errors
}

export default validate;